import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/news/_components/ClientSideNewsWrapper/ClientSideNewsWrapper.tsx");
